module.exports = __webpack_public_path__ + "static/media/yves_rocher.c9a7d1a0.webp";